var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio',{staticClass:"app-radio",attrs:{"value":_vm.value,"dark":"","color":"primary","on-icon":"mdi-check-circle","off-icon":"mdi-check-circle"},on:{"click":function($event){return _vm.$emit('input', _vm.value)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }